import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { BdpkDeveloperEnv } from "./bdpk-developer-env";
let BdpkDeveloperEnvCategory = class BdpkDeveloperEnvCategory {
    constructor() {
        this.devEnvironments = [];
        this.isMenuOpen = false;
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], BdpkDeveloperEnvCategory.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnvCategory.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], BdpkDeveloperEnvCategory.prototype, "ord", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnvCategory.prototype, "description", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnvCategory.prototype, "imagePath", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkDeveloperEnvCategory.prototype, "createUserId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnvCategory.prototype, "createUserName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkDeveloperEnvCategory.prototype, "createDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkDeveloperEnvCategory.prototype, "changeUserId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnvCategory.prototype, "changeUserName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkDeveloperEnvCategory.prototype, "changeDate", void 0);
tslib_1.__decorate([
    jsonArrayMember(BdpkDeveloperEnv, { emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], BdpkDeveloperEnvCategory.prototype, "devEnvironments", void 0);
BdpkDeveloperEnvCategory = tslib_1.__decorate([
    jsonObject()
], BdpkDeveloperEnvCategory);
export { BdpkDeveloperEnvCategory };
